const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const LOCAL_ANTHROPIC_KEY = String(process.env.REACT_APP_ANTHROPIC_API_KEY || "")
  .trim()
  .replace(/^['"]+|['"]+$/g, "");
const USE_LOCAL_DIRECT_ANTHROPIC_FALLBACK = !API_BASE_URL && !!LOCAL_ANTHROPIC_KEY;

function getErrorMessage(status, data) {
  const apiMessage = data?.error?.message || data?.message;
  if (apiMessage) return apiMessage;
  if (status === 401 || status === 403) return "Anthropic request not authorized.";
  if (status === 404) return "Anthropic proxy endpoint not found. Start backend proxy or set REACT_APP_API_BASE_URL.";
  if (status >= 500) return "Anthropic service is temporarily unavailable.";
  return `Anthropic proxy error (HTTP ${status}).`;
}

export async function callAnthropicMessages(payload) {
  const response = await fetch(
    USE_LOCAL_DIRECT_ANTHROPIC_FALLBACK
      ? "https://api.anthropic.com/v1/messages"
      : `${API_BASE_URL}/api/anthropic/messages`,
    {
      method: "POST",
      headers: USE_LOCAL_DIRECT_ANTHROPIC_FALLBACK
        ? {
            "Content-Type": "application/json",
            "x-api-key": LOCAL_ANTHROPIC_KEY,
            "anthropic-version": "2023-06-01",
            "anthropic-dangerous-direct-browser-access": "true",
          }
        : { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(getErrorMessage(response.status, data));
    err.status = response.status;
    err.userMessage = getErrorMessage(response.status, data);
    throw err;
  }
  return data;
}
